import NewsTipStatus from './NewsTipCreatedSimpleView'

export default NewsTipStatus
